import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneAlt } from "@fortawesome/pro-regular-svg-icons/faPhoneAlt";

export const defaultTranslations = {
    pluginName: "Callbird",
    pluginDescription: "Add Callbird button",
};

export const defaultSettings = {
    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin was not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faPhoneAlt} size="3x" />,
};
